module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui form-customers",
    class: {
      segments: _vm.segments
    }
  }, [_vm._l((_vm.customers), function(customer, index) {
    return _c('form-new-customer', {
      key: index,
      ref: "customers",
      refInFor: true,
      staticClass: "ui",
      class: {
        segment: _vm.segments
      },
      attrs: {
        "cancelable": _vm.cancelable,
        "form": customer,
        "removable": _vm.removable && _vm.customers.length > 1
      },
      on: {
        "remove": _vm.customer_remove
      }
    })
  }), _c('div', {
    staticClass: "ui right aligned",
    class: {
      segment: _vm.segments
    }
  }, [_c('div', {
    staticClass: "ui button tiny themed icon labeled",
    on: {
      "click": _vm.customer_add
    }
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v("添加住户")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa9e8408","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormCustomers.vue
// module id = 367
// module chunks = 0